export function getProtooUrl({ roomId, peerId }) {
  const hostname = window.location.hostname;

  return `wss://${hostname}/media-server?roomId=${roomId}&peerId=${peerId}`;
}
